import { useState } from 'react';
import { NavItem } from '../Header/MegaNavigation/MegaNavigation.types';
import { AccordionItem } from './AccordionItem';

export interface NestedAccordionProps {
  data: NavItem[];
}

export const NestedAccordion = ({ data }: NestedAccordionProps) => {
  const [openItems, setOpenItems] = useState<Record<string, boolean>>({});

  const toggleOpen = (key: string) => {
    setOpenItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <>
      {data.map((item, idx) => (
        <AccordionItem
          item={item}
          keyPrefix=""
          level={0}
          index={idx}
          openItems={openItems}
          toggleOpen={toggleOpen}
          key={`root-${item.id}-${idx}`}
        />
      ))}
    </>
  );
};
